// extracted by mini-css-extract-plugin
module.exports = {"footerBar":"footer_footerBar__2_HMq","footerLinks":"footer_footerLinks__20_IR","social":"footer_social__25MFE","copyRight":"footer_copyRight__3hqpl"};